var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubInput = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2,
  height: 16,
  viewBox: "0 0 2 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V16",
  stroke: "#DCDFE0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubInput);
export default ForwardRef;